module.exports = __webpack_public_path__ + "static/media/qrborder.61b73c61.svg";